import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export type AuthState = {
  isAuthenticated: boolean
  /** Cached from Auth0 ID token custom claim https://inflectionmedicine.com/familyMemberId */
  familyMemberId?: string
}

const initialState: AuthState = {
  isAuthenticated: false,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthenticated(state, action: PayloadAction<{ isAuthenticated: boolean }>) {
      state.isAuthenticated = action.payload.isAuthenticated
    },
    setFamilyMemberId(state, action: PayloadAction<string | undefined>) {
      state.familyMemberId = action.payload
    },
    clearAuth(state) {
      state.isAuthenticated = false
      state.familyMemberId = undefined
    },
  },
})

export const { setAuthenticated, setFamilyMemberId, clearAuth } = authSlice.actions
export default authSlice.reducer
